import React from 'react'
import GetSample from './GetSamples'

class SampleModes extends React.Component {

    constructor(props){
      super(props)
    }
    
   
  
   render(props) {
    const record= this.props.record
    return(
    <div>
        {record&& record.test_mode === 'ATYA' && <GetSample record={record}   mode={'ATYA'}  />}
        {record&& record.test_mode === 'SPE' &&<GetSample record={record}   mode={'SPE'}  />}
        {record&& record.test_mode === 'VMT' &&<GetSample record={record}   mode={'VMT'}  />}
        {record&& record.test_mode === 'NAT' &&<GetSample record={record}   mode={'NAT'}  />}
    </div>
    )
  }
}

export default SampleModes